import { useEffect, useState } from "react";

function getScrollbarWidth(): number {
  if (typeof window === "undefined") return 15;

  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll";
  outer.style.width = "100px";
  outer.style.height = "100px";
  outer.style.position = "absolute";
  outer.style.top = "-9999px";

  document.body.appendChild(outer);

  const inner = document.createElement("div");
  inner.style.width = "100%";
  inner.style.height = "200px";
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  document.body.removeChild(outer);

  return scrollbarWidth;
}

let cachedScrollbarWidth: number | null = null;

export function useScrollbarWidth(): number {
  const [width, setWidth] = useState(() => {
    if (cachedScrollbarWidth !== null) {
      return cachedScrollbarWidth;
    }
    return 15;
  });

  useEffect(() => {
    if (cachedScrollbarWidth === null) {
      const measuredWidth = getScrollbarWidth();
      cachedScrollbarWidth = measuredWidth;
      setWidth(measuredWidth);
    }
  }, []);

  return width;
}
